import React from 'react';
import { Select, MenuItem, useTheme } from '@mui/material';

const DropdownFilter = ({ title, value, onChange, options }) => {
    const theme = useTheme(); // Get the current MUI theme

    return (

        <div className=" px-3 py-1 rounded flex items-center">
            <span className="text-sm text-gray-500 mr-2">{title}:</span>
            <Select
                value={value}
                onChange={onChange}
                size="small"
                variant="standard"
                sx={{
                    color: '#00DEC3',
                    fontSize: '0.875rem',
                    '& .MuiSelect-icon': { color: theme.palette.primary.main },
                    '&:before': { borderBottom: 'none' },
                    '&:after': { borderBottom: 'none' }
                }}
            >
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </div>
    );
};

export default DropdownFilter;
